// Auto refresh waits for the current request; explicit period changes may supersede it.
export function createChartRequestGate() {
  let current = 0, busy = false;
  return {
    start(autoUpdate) {
      if (autoUpdate && busy) return null;
      busy = true;
      return ++current;
    },
    isCurrent(token) { return token === current; },
    finish(token) {
      if (token !== current) return false;
      busy = false;
      return true;
    },
  };
}
